import { createAction, props } from '@ngrx/store';
import {User} from '../models/user';

export enum UserActionTypes {
  Login = '[User] Login',
  LoginSuccess = '[User] Login Success',
  LoginFailure = '[User] Login Failure',
  Logout = '[User] Logout'
}

export const login = createAction(
  UserActionTypes.Login,
  props<{ username: string, password: string}>()
);

export const loginSuccess = createAction(
  UserActionTypes.LoginSuccess,
  props<{ user: User }>()
);

export const loginFailure = createAction(
  UserActionTypes.LoginFailure,
  props<{ error: string }>()
);

export const logout = createAction(
  UserActionTypes.Logout
);
